<template>
  <div class="season-total-point">
    <div class="show-main">
      <div class="teams">
        <div v-for="(item,idx) in teams" :key="idx" class="team">
          <div class="team-label" :style="'background-image:url('+team[`team${item.id}`]+')'" />
          <!-- <div class="team-label" v-html="$dataManager.findTeam(item.id).team.icon" /> -->
          <!-- <div class="team-label" :style="'background-color:'+$dataManager.findTeam(item.id).team.color" v-text="$dataManager.findTeam(item.id).team.displayName" /> -->
          <div class="team-point" :style="'color:'+$dataManager.findTeam(item.id).team.color">
            <svg id="_6" data-name="6" xmlns="http://www.w3.org/2000/svg" width="222" height="99" viewBox="0 0 222 99">
              <path data-name="TEAM POINTS" :fill="$dataManager.findTeam(item.id).team.color" fill-rule="evenodd" d="M37.141,0.455H-0.218v7.9H13.6V43.293h9.772V8.351H37.141v-7.9Zm38.495,35.04H51.9V25.378H73.563v-7.8H51.9V8.351h23.1v-7.9H42.224V43.293H75.636v-7.8Zm29.019-35.04H93.107L77.215,43.293H87.628l3.011-9.525h16.286l3.159,9.525h10.561ZM92.81,26.365L97.647,11.9a32,32,0,0,0,1.036-3.8h0.1a20.836,20.836,0,0,0,1.036,3.652L105.1,26.365H92.81Zm75.953-25.91H154.4L146.851,28.29a22.675,22.675,0,0,0-.543,4.639h-0.1a23.788,23.788,0,0,0-.542-4.59l-7.5-27.884H123.853V43.293h9.13V19.653q0-5.23-.4-11.548h0.148q0.741,3.653,1.53,6.465l7.9,28.723h8.143l7.945-27.884a70.1,70.1,0,0,0,1.481-7.255h0.148q-0.346,4.985-.345,9.525V43.293h9.228V0.455ZM27.468,81.7q7.4-3.109,7.4-12.535a12.319,12.319,0,0,0-3.9-9.574q-4.245-3.9-12.239-3.9H1.114V98.53h9.673V83.281h7.107A24.859,24.859,0,0,0,27.468,81.7h0Zm-4.59-16.78a6.673,6.673,0,0,1-.1,9.377A8.709,8.709,0,0,1,17.1,75.927H10.787V63.145H17.1a8.367,8.367,0,0,1,5.774,1.777h0ZM75.34,61.664Q69.418,55.1,59.843,55.1q-9.871,0-15.645,6.317Q38.721,67.439,38.72,77.21q0.2,10.118,5.972,16.04,5.823,5.922,15.151,6.07,9.376,0,15.2-6.07,5.873-6.119,5.873-16.04,0-9.327-5.577-15.546h0Zm-7.8,25.614a9.5,9.5,0,0,1-7.946,3.6,9.517,9.517,0,0,1-7.65-3.455q-3.159-3.7-3.159-10.216,0-6.317,3.011-10.117a9.588,9.588,0,0,1,7.847-3.751,9.335,9.335,0,0,1,7.847,3.751q2.862,3.7,2.862,10.117,0,6.466-2.813,10.068h0ZM95.673,55.693H86V98.53h9.673V55.693Zm44.022,0h-9.081V79.431q0,2.913.247,6.465l-0.049.1A34,34,0,0,0,128.64,81.8L112.354,55.693H101.99V98.53h9.081V74.94q0-4.934-.247-7.3h0.049q1.086,2.122,2.271,4l16.829,26.9H139.7V55.693Zm42.492,0H144.828v7.9h13.818V98.53h9.772V63.589h13.769v-7.9Zm9.426,39.975q4.639,3.652,13.276,3.652,8.241,0,12.684-3.8a12.175,12.175,0,0,0,2.418-15.151,12.933,12.933,0,0,0-5.33-4.935,38.259,38.259,0,0,0-10.068-3.455,16.872,16.872,0,0,1-5.873-2.172,3.661,3.661,0,0,1-1.53-3.109,3.331,3.331,0,0,1,1.431-2.764,7.3,7.3,0,0,1,4.541-1.283,8.4,8.4,0,0,1,5.626,1.727,6.921,6.921,0,0,1,2.221,4.491l9.426-1.777q-1.481-6.119-5.527-8.982-4.294-3.01-12.19-3.011-6.958,0-11.351,3.405a9.893,9.893,0,0,0-4.245,8.143,11.252,11.252,0,0,0,2.567,7.8q2.664,2.961,8.834,4.392a53.446,53.446,0,0,1,8.39,2.468,7.974,7.974,0,0,1,3.553,2.369,4.882,4.882,0,0,1,.888,3.011,4.4,4.4,0,0,1-1.727,3.6,7.78,7.78,0,0,1-5.034,1.481q-8.29.148-9.574-8.834l-9.427,1.875q1.579,7.4,6.021,10.858h0Z" />
            </svg>
          </div>
          <div class="team-score" :style="'color:'+$dataManager.findTeam(item.id).team.color">
            <span v-text="$dataManager.findTeam(item.id).team.teamScore" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import team139 from '@/assets/todayTotalPoint/139.png'
import team140 from '@/assets/todayTotalPoint/140.png'
import team141 from '@/assets/todayTotalPoint/141.png'
import team142 from '@/assets/todayTotalPoint/142.png'
import team143 from '@/assets/todayTotalPoint/143.png'
import team144 from '@/assets/todayTotalPoint/144.png'
import team145 from '@/assets/todayTotalPoint/145.png'
import team146 from '@/assets/todayTotalPoint/146.png'
export default {
  name: 'SeasonTotalPoint',
  data() {
    return {
      season: {},
      teams: {},
      isLoading: false,
      liveSetting: {},
      team: {
        team132: team139,
        team133: team140,
        team134: team141,
        team136: team142,
        team139: team139,
        team140: team140,
        team141: team141,
        team142: team142,
        team143: team143,
        team144: team144,
        team145: team145,
        team146: team146
      }
    }
  },
  computed: {
    title: function() {
      return this.season.name ? this.season.name.indexOf('N') !== -1 ? 'N' : 'S' : ''
    },
    fontSize: function() {
      var domain = 'www.supermahjongleague.com'
      var width = window.innerWidth
      const fontSize = ((width - 80) / (1 + Math.max((domain).split('\n').map(t => t.length))))
      return 'font-size:' + fontSize + 'px;flex:0 ' + fontSize
    }
  },
  mounted() {
    this.$bus.$on('liveSetting', content => {
      this.liveSetting = content
      this.getData()
    })
  },
  methods: {
    getRankStr: function(idx) {
      var data = ''
      switch (idx) {
        case 1:
          data = '1st'
          break
        case 2:
          data = '2nd'
          break
        case 3:
          data = '3rd'
          break
        case 4:
          data = '4th'
          break
        case 5:
          data = '5th'
          break
        case 6:
          data = '6th'
          break
      }
      return data
    },
    getData: function() {
      this.$store.commit('CLOSE_LOADING')
      this.$store.dispatch('getData', { type: 'Season', credentials: this.liveSetting.seasonId }).then((res) => {
        if (!res.errorCode) {
          this.season = res.data
          this.teams = res.data.teams
          this.teams.sort(function(a, b) {
            return a.teamRank - b.teamRank
          })
          this.$store.commit('UPDATE_TEAM', res.data.teams)
          this.isLoading = true
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../../style/show/seasonTotalPoint';
</style>
